module.exports = "/images/folder-big.png?21a9feb2a144fafc9e2bd8fda0528185";